import { TeamType, UserType } from '@api';
import { Modal } from '@mantine/core';
import { TaskForm } from './TaskForm';
import { TaskFormSchemaType } from './hooks';

type TaskFormModalPropsType = {
  opened: boolean;
  onClose: () => void;
  onSubmit: (data: TaskFormSchemaType) => Promise<void>;
  defaultValues: TaskFormSchemaType;
  title: string;
  users: UserType[];
  teams: TeamType[];
};

export const TaskFormModal: React.FC<TaskFormModalPropsType> = ({
  opened,
  onClose,
  onSubmit,
  defaultValues,
  title,
  users,
  teams,
}) => {
  const handleSubmit = async (data: TaskFormSchemaType): Promise<void> => {
    await onSubmit(data);
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      size="lg"
      closeOnClickOutside={false}
    >
      {opened ? (
        <TaskForm
          defaultValues={defaultValues}
          onSubmit={handleSubmit}
          onCancel={onClose}
          users={users}
          teams={teams}
        />
      ) : null}
    </Modal>
  );
};
